import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Nav, Navbar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Drawer, DrawerItem } from '@progress/kendo-react-layout';
// @ts-ignore
import SiteLogo from 'assets/images/FLHealthLogo2.png';
import { mediaQueryKeys } from 'utility/constants';
import { useKeyPress } from 'hooks/use_key_press';
import { useBreakpoint } from '../context/breakpoint_provider';
// @ts-ignore
import styles from './site.module.scss';
import { globalEndpoints } from '../../../endpoints/global';

const NavItem = (props) => {
  const icon = props.icon?.indexOf(' ') >= 0 ? props.icon?.split(' ') : props.icon;
  const { visible, ...others } = props;
  const arrowDir = props.parentExpanded
    ? 'angle-up'
    : 'angle-down';
  const requiresRefresh = props.route?.includes('refresh');

  if (props.route.startsWith('api')) {
    return (
      <DrawerItem {...props} tabIndex={-1}>
        <Nav.Link as="a" href={`${globalEndpoints.apiUrl}${props.route.replace('api', '')}`}>
          <div className="d-flex">
            <div className={`fa-fw d-flex align-items-center justify-content-center ${styles.dropdownMenuIcon}`}>
              {props?.icon && <FontAwesomeIcon icon={icon} />}
            </div>
            <div className="pl-3 flex-column">
              <div>{props.text}</div>
            </div>
          </div>
        </Nav.Link>
      </DrawerItem>
    );
  }

  return (
    !visible ? null : (
      <DrawerItem {...others}>
        <Nav.Link as={requiresRefresh ? 'a' : Link} to={requiresRefresh ? undefined : props.route} href={requiresRefresh ? `/spa${props.route}` : undefined} disabled={props.parentExpanded !== undefined}>
          <div className="d-flex align-self-start">
            {props.parentId !== undefined && (
            <span>
                  &nbsp;&nbsp;&nbsp;
            </span>
            )}
            <div className={`d-flex pt-2 justify-content-center ${styles.dropdownMenuIcon}`}>
              {props?.icon && <FontAwesomeIcon icon={icon} />}
            </div>
            <div className="pl-3 flex-column">
              <div>{props.text}</div>
            </div>
            <div className="pl-3">
              {props.parentExpanded !== undefined && (
              <span>
                <FontAwesomeIcon icon={arrowDir} />
              </span>
              )}
            </div>
          </div>
        </Nav.Link>
      </DrawerItem>
    )
  );
};

export const MobileMenu = (props) => {
  const [expanded, setExpanded] = useState(false);
  const breakpoints = useBreakpoint();

  useKeyPress('Escape', () => {
    setExpanded(false);
  }, '');

  // Method created to handle a select event on the items
  const onSelect = (event) => {
    const currentItem = event.itemTarget.props;
    const isParent = Object.prototype.hasOwnProperty.call(currentItem, 'parentExpanded');
    const itemId = currentItem.id;
    if (isParent) {
      props.onParentSelect(itemId);
    } else {
      setExpanded(false);
    }
  };

  return (
    <Navbar
      expanded={expanded}
      collapseOnSelect
      bg="light"
      expand="lg"
      fixed="top"
      sticky="top"
      className={styles.mobileMenuNavbar}
    >
      <Navbar.Brand className={styles.navbarBrand}>
        <Nav.Link as={Link} to="/" className={`pl-0 ${styles.navLink}`}>
          <img alt="OMMU Site Logo" className={styles.mobileMenuLogo} src={SiteLogo} />
          <span className={styles.mobileMenuText}>
            {breakpoints[mediaQueryKeys.xsOnly] ? 'OMMU Registry' : 'Medical Marijuana Use Registry'}
          </span>
        </Nav.Link>
      </Navbar.Brand>
      <Navbar.Toggle
        className={`ml-auto btn ${styles.navbarToggler}`}
        onClick={() => setExpanded(!expanded)}
        aria-controls="responsive-navbar-nav"
      />
      <Drawer
        expanded={expanded}
        items={props.menuItems}
        item={NavItem}
        position="end"
        mode="overlay"
        animation={{ duration: 350 }}
        onOverlayClick={() => setExpanded(false)}
        onSelect={onSelect}
      />
    </Navbar>
  );
};
